'use strict';

angular.module('mean.admin').controller('AdminTosController', ['$scope', 'Global', 'Menus', 'MeanUser', '$filter', 'Users', 'toaster', 'NgTableParams',
  function($scope, Global, Menus, MeanUser, $filter, Users, toaster, NgTableParams) {
  $scope.global = Global;
  $scope.package = {
    name: 'admin'
  };
  $scope.users = [];
  $scope.data = [];

  Users.query({/*'agreed_to_tos': false*/}, function(users) {
    $scope.users = users;

    $scope.data = $filter('orderBy')(users, 'username');

    $scope.tableListToSParams = new NgTableParams({ count: 50 }, { dataset: $scope.data });
  });

  // $scope.reloadTable = function() {
  //   var data = $scope.users;
  //   $scope.tableListToSParams.reload();
  // };

  // $scope.hideUsers = function() {
  //   $scope.data = $filter('filter')($scope.users, {'agreed_to_tos': !this.hide_users}, true);
  //   $scope.tableListToSParams.reload();
  // };

  $scope.update = function(user) {
    console.log('in update');
    user.$update().then(function(result) {
      toaster.pop('success', 'User Updated', 'Saved');
      $scope.reloadTable();
    }, function(reason) {
      toaster.pop('error', 'User Update Error', reason);
    });
  };
}]);



// WEBPACK FOOTER //
// ./packages/custom/admin/public/controllers/adminTosController.js